// extracted by mini-css-extract-plugin
export default {"waysToStyleGalleryButtonWrapper":"aHKCP"};